/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `1` - Lună
 * * `12` - An
 */
export enum Period1acEnum {
  '_1' = 1,
  '_12' = 12,
}
